import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const MyJaaqContext = React.createContext();

export const useMyJaaqContext = () => useContext(MyJaaqContext);

export function MyJaaqProvider({ children }) {
  const [likedExperiences, setLikedExperiences] = useState([]);
  const [likedHeading, setLikedHeading] = useState({});
  const [recommendedExperiences, setRecommendedExperiences] = useState([]);
  const [recommendedHeading, setRecommendedHeading] = useState({});
  const [articles, setArticles] = useState([]);
  const [exploreSidebar, setExploreSidebar] = useState({});
  const [boards, setBoards] = useState({});
  const [switcherButtons, setSwitcherButtons] = useState({});

  useEffect(() => {
    fetchData
      .get('https://run.mocky.io/v3/09946980-1d9c-4c93-9732-810a37c49c50')
      .then(setLikedExperiences);
    fetchData
      .get('https://run.mocky.io/v3/0cc6f517-15ef-4394-b9d9-b37673a4cfbc')
      .then(setLikedHeading);
    fetchData
      .get('https://run.mocky.io/v3/300e0009-0939-442a-9afa-e346c2870c2e')
      .then(setRecommendedExperiences);
    fetchData
      .get('https://run.mocky.io/v3/af05e335-fbc4-43df-b768-3e1f82b83702')
      .then(setRecommendedHeading);
    fetchData.get('https://run.mocky.io/v3/3637c61b-974e-417b-9a0f-26bd36035457').then(setArticles);
    fetchData
      .get('https://run.mocky.io/v3/bedfb734-2730-49f3-b179-877b66e8d366')
      .then(setExploreSidebar);
    fetchData.get('https://run.mocky.io/v3/dd7fbca2-7664-411f-a9b0-c98a18967106').then(setBoards);
    fetchData
      .get('https://run.mocky.io/v3/d50ad4c2-c1e1-4609-8a21-bea7f633c71c')
      .then(setSwitcherButtons);
  }, []);

  const value = useMemo(
    () => ({
      likedExperiences,
      likedHeading,
      recommendedExperiences,
      recommendedHeading,
      articles,
      exploreSidebar,
      boards,
      switcherButtons,
    }),
    [
      likedExperiences,
      likedHeading,
      recommendedExperiences,
      recommendedHeading,
      articles,
      exploreSidebar,
      boards,
      switcherButtons,
    ]
  );

  return <MyJaaqContext.Provider value={value}>{children}</MyJaaqContext.Provider>;
}
